<template>
  <!-- <md-tab
    id="tab-account-activity"
    md-label="Account Activity"
    md-icon="devices"
  >
  </md-tab> -->
  <!-- <collapse :collapse="['Account Activity']" icon="keyboard_arrow_down" cardIcon="auto_graph" color-collapse="info" :active="false">
    <template slot="md-collapse-pane-1">
      <div class="md-layout py-4" v-if="!loading">
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
          <div class="navbar md-toolbar md-transparent md-elevation-4 p-0">
            <div class="md-toolbar-row p-0">
              <div class="md-toolbar-section-end">
                <div class="links">
                  <div class="datepicker-box">
                    <datetime
                      format="MM/DD/YYYY"
                      width="300px"
                      v-model="dateFrom"
                      @input="getAnotherPage"
                    ></datetime>
                  </div>
                  <div class="datepicker-box" style="margin-right: 30px">
                    <datetime
                      format="MM/DD/YYYY"
                      width="300px"
                      v-model="dateTo"
                      @input="getAnotherPage"
                    ></datetime>
                  </div>
                  <select
                    class="selectpicker"
                    data-style="btn btn-primary btn-round"
                    title="By Product Type"
                    data-size="7"
                    @change="getAnotherPage"
                    v-model="type"
                  >
                    <option value=""> By Descending order</option>
                    <option value="team">By Team Member</option>
                    <option value="product">By Product Type</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
          <md-table
            v-model="activity"
            table-header-color="blue"
            v-if="!loadingPage"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Date">{{ item.date }}</md-table-cell>
              <md-table-cell md-label="Team Member">{{
                item.teamMember
              }}</md-table-cell>
              <md-table-cell md-label="Client">{{ item.client }}</md-table-cell>
              <md-table-cell md-label="Product Type">{{
                item.productType
              }}</md-table-cell>
              <md-table-cell md-label="Release">{{ item.release }}</md-table-cell>
            </md-table-row>
          </md-table>
        </div>
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
          <div class="navbar md-toolbar md-transparent md-elevation-4 p-0">
            <div class="md-toolbar-row p-0">
              <div class="md-toolbar-section-start">
                <div class="pagin-page-info">
                  Showing page: {{ pagination.currentPage }} of
                  {{ pagination.total }}
                </div>
              </div>
              <div class="md-toolbar-section-end">
                <pagination
                  class="pagination-info"
                  v-model="pagination.currentPage"
                  :per-page="pagination.perPage"
                  :total="pagination.total"
                  @click.native="getAnotherPage"
                >
                </pagination>
              </div>
            </div>
          </div>
        </div>
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 card-buttons">
          <div class="button-container">
            <md-button class="md-info" :href="'/'" target="_blank"
              >EXPORT CSV
            </md-button>
          </div>
        </div>
      </div>
    </template>
  </collapse> -->
  <div class="billing_sec">
    <div class="md-layout py-4" v-if="!loading">
      <table-card>
        <template slot="header">
          <h4 class="title">Account Activity</h4>
          <div class="md-toolbar-section-end sorting_area">
            <div class="links">
              <div class="datepicker-box">
                <datetime format="MM/DD/YYYY" v-model="dateFrom" @input="getAnotherPage" md-icon="calendar_month">
                </datetime>
              </div>
              <div class="datepicker-box">
                <datetime format="MM/DD/YYYY" v-model="dateTo" @input="getAnotherPage"></datetime>
              </div>
              <select title="Select picker" class="selectpicker" data-style="btn btn-primary btn-round"  data-size="7"
                @change="getAnotherPage" v-model="type">
                <option value=""> By Descending order</option>
                <option value="team">By Team Member</option>
                <option value="product">By Product Type</option>
              </select>
            </div>
          </div>
        </template>
        <template slot="content">
          <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
              <md-table v-model="activity" table-header-color="blue" v-if="!loadingPage"
                class="billing-and-invoices-table">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="Date">{{ getFormattedDate(item.date) }}
                  </md-table-cell>
                  <md-table-cell md-label="Team Member">{{
                    item.teamMember?item.teamMember:''
                    }}</md-table-cell>
                  <md-table-cell md-label="Product Type">{{
                    item.productType?item.productType:''
                    }}</md-table-cell>
                  <md-table-cell md-label="Release">{{
                    item.release?item.release:''
                    }}</md-table-cell>
                </md-table-row>
              </md-table>
            </div>
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
              <div class="navbar md-toolbar md-transparent md-elevation-4 p-0">
                <div class="md-toolbar-row p-0">
                  <div class="md-toolbar-section-start">
                    <div class="pagin-page-info">
                      Showing page: {{ pagination.currentPage }} of
                      {{ pagination.total }}
                    </div>
                  </div>
                  <div class="md-toolbar-section-end">
                    <pagination class="pagination-info" v-model="pagination.currentPage" :per-page="pagination.perPage"
                      :total="pagination.total" @click.native="getAnotherPage">
                    </pagination>
                  </div>
                </div>
              </div>
            </div>
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 card-buttons">
              <div class="button-container">
                <md-button class="md-info md-round dark-blue-color" @click="downloadCSVData">EXPORT CSV<md-icon class="m-0">receipt_long
                  </md-icon>
                </md-button>
              </div>
            </div>
          </div>
        </template>
      </table-card>
    </div>
  </div>
</template>
<script>
import { Pagination, TableCard, Collapse } from '@/components';
import datetime from 'vuejs-datetimepicker';
import axios from 'axios';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

export default {
  props: ['account'],
  name: 'products-accessed-tab',
  components: {
    Pagination,
    TableCard,
    datetime,
    // Collapse
  },
  data() {
    return {
      type: '',
      dateFrom: null,
      dateTo: null,
      loading: true,
      loadingPage: false,
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: undefined,
      },
      tableData: [],
      csvDateFrom: null,
      csvDateTo: null,
      csvTableData: [],
    };
  },
  async created() {
    await this.getSubscriptionsActivity();
  },
  computed: {
    activity() {
      return this.tableData.map((item) => {
        let apiDate = new Date(item.date.replace(/-/g, "/"));
        let resultDate = `${apiDate.getMonth() +
          1}/${apiDate.getDate()}/${apiDate.getFullYear()}`;

        return {
          date: resultDate,
          teamMember: item.member,
          client: item.client,
          productType: item.product,
          release: item.release,
        };
      });
    },
  },
  methods: {
    getFormattedDate(date) {
      if (date) {
        let newDate = new Date(date.replace(/-/g, "/"));
        let day = newDate.getDate().toString().padStart(2, '0');
        let month = (newDate.getMonth() + 1).toString().padStart(2, '0');
        let year = newDate.getFullYear().toString().substr(-2);
        return `${month}/${day}/${year}`;
      }
      return '';
    },
    createDateString(date) {
      let tempDate = new Date(date.replace(/-/g, "/"));
      return `${tempDate.getMonth() +
        1}/${tempDate.getDate()}/${tempDate.getFullYear()}`;
    },
    async getAnotherPage(event) {
      this.loadingPage = true;
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      var date = new Date();
      var dateLastYear = new Date(
        new Date().setFullYear(new Date().getFullYear() - 1)
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/subscriptions/activity',
          {},
          {
            params: {
              session_id: currentSession,
              page: this.pagination.currentPage,
              itemsPerPage: this.pagination.perPageOptions[0],
              order: this.type,
              date_from: this.dateFrom ? new Date(this.dateFrom) : dateLastYear,
              date_to: this.dateTo ? new Date(this.dateTo) : date,
              onlyMe: this.account,
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/subscriptions/activity" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          this.pagination.total = res.data.totalPages;
          this.loadingPage = false;


          this.tableData = res.data.activity;
        });
    },
    async getSubscriptionsActivity(itemsPerPage = null) {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      var date = new Date();
      var dateLastYear = new Date(
        new Date().setFullYear(new Date().getFullYear() - 1)
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/subscriptions/activity',
          {},
          {
            params: {
              session_id: currentSession,
              page: this.pagination.currentPage,
              itemsPerPage: itemsPerPage
                ? itemsPerPage
                : this.pagination.perPageOptions[0],
              date_from: this.dateFrom ? new Date(this.dateFrom) : dateLastYear,
              date_to: this.dateTo ? new Date(this.dateTo) : date,
              onlyMe: this.account,
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/subscriptions/activity" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          // this.dateFrom = this.createDateString(new Date());
          // this.dateTo = this.createDateString(new Date());
          this.pagination.total = res.data.totalPages;
          this.loading = false;
          this.tableData = res.data.activity;
        });
    },
    async getCSVSubscriptionsActivity(itemsPerPage = null) {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      var date = new Date();
      var dateLastYear = new Date(
        new Date().setFullYear(new Date().getFullYear() - 1)
      );

      return await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/subscriptions/activity',
          {},
          {
            params: {
              session_id: currentSession,
              page: this.pagination.currentPage,
              itemsPerPage: itemsPerPage
                ? itemsPerPage
                : this.pagination.perPageOptions[0],
              date_from: this.dateFrom ? new Date(this.dateFrom) : dateLastYear,
              date_to: this.dateTo ? new Date(this.dateTo) : date,
              onlyMe: this.account,
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/subscriptions/activity" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          // this.csvDateFrom = this.createDateString(new Date());
          // this.csvDateTo = this.createDateString(new Date());
          // this.pagination.total = res.data.totalPages;
          // this.loading = false;
          return res.data.activity;
        });
    },
    async downloadCSVData() {
      let csv = '';
      this.csvTableData = await this.getCSVSubscriptionsActivity(250);

      if (this.csvTableData.length) {
        let csvData = await this.getCsvData();

        csvData.forEach((row) => {
          csv += row.join(',');
          csv += '\n';
        });
        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
        anchor.target = '_blank';
        anchor.download = 'Account Activity.csv';
        anchor.click();
      }
    },
    async getCsvData() {
      let csvData = [
        ['Date', 'Team Member', 'Client', 'Product Type', 'Release'],
      ];
      this.csvTableData.forEach((e, i) => {
        csvData.push([e.date, e.member, e.client, e.product, e.release]);
      });
      return csvData;
    },
  },
};
</script>
<style></style>
